import { Box, getThemeColor, getThemeSpacing } from '@fairfashion/design-system'
import { styled } from 'styled-components'

export const Container = styled(Box)`
  position: absolute;
  top: ${({ theme }) => getThemeSpacing(2, theme)};
  right: ${({ theme }) => getThemeSpacing(2, theme)};
`

export const MenuOption = styled(Box)`
  width: 100%;
  padding: 10px 12px;
  gap: 6px;
  align-items: center;
  font-size: 13px;

  cursor: pointer;

  transition: background 0.2s;

  &:hover {
    background: ${({ theme }) => getThemeColor('grey_5', theme)};
  }
`

export const DetailsText = styled(Box)`
  width: 100%;
  display: flex;
  flex-direction: column;
  gap: 16px;
  color: ${({ theme }) => getThemeColor('grey_3', theme)};
  font-size: 14px;
`
